import angular from "angular";
import lodash from "./lodash";

function ConfigService(_, $log, $http, $window, $q, socketIo, Events, $rootScope) {

    var client;

    function init() {

        // socketIo.on("configChanged", (config) => {
        /*
        TODO: should we really react to all config changes without reloading?

        $window.STATE = config;
        $rootScope.$emit(Events.CONFIG_CHANGED,$window.STATE);
        */
        //$rootScope.$emit(Events.CONFIG_CHANGED,config);
        // });

        // socketIo.on("maintenanceChanged", (maintenance) => {
        //     $window.STATE.maintenance = maintenance;
        //     $rootScope.$emit(Events.CHECK_MAINTENANCE, maintenance);
        //     $log.info("ConfigService: maintenance changed to ", maintenance);
        // });

        // client = $window.STATE.client;
    }

    function getValue(key, preventWarning, defaultValue, language) {
        var result;
        if (language) {
            // Wenn eine language übergeben wird => Key + .language, Fallback: Key + .fallback, Fallback: Key, Fallback: defaultValue bzw §$%&default
            result = _.get($window.STATE, key + "." + language) ||
                _.get($window.STATE, key + ".fallback") ||
                _.get($window.STATE, key, defaultValue || "§$%&default");
        } else { // Ohne language => Key, Fallback: defaultValue bzw §$%&default
            result = _.get($window.STATE, key, defaultValue || "§$%&default");
        }
        if (result === "§$%&default") {
            if (!preventWarning) {
                $log.warn("Warning: Config Value: ", key, " not found");
            }
            return undefined;
        }
        else {
            return result;
        }
    }

    function get(key, preventWarning, defaultValue, language) {
        return getValue(key, preventWarning, defaultValue, language);
    }

    function getClient() {
        return client;
    }

    function getContext() {
        return get("context", true, "CON");
    }

    function getValueAsync(key, preventWarning, defaultValue, refresh) {
        return $q((resolve, reject) => {
            if (refresh) {
                loadConfig().then(function (config) {
                    resolve(getValue(key, preventWarning, defaultValue));
                });
            }
            else {
                resolve(getValue(key, preventWarning, defaultValue));
            }
        });
    }

    function set(config) {
        $window.STATE = config;
    }

    function loadConfig() {
        //console.log("load config");
        return $q((resolve, reject) => {
            $http.get("/configuration").then((res) => {
                var config = res.data;
                $window.STATE = res.data;
                resolve(config);
            }, (err) => {
                console.error("ERROR: ", err);
                reject(err);
            });
        });
    }

    function isLocalStorageAvailable() {
        var test = 'test';
        try {
            localStorage.setItem("test", "test");
            localStorage.removeItem("test");
            return true;
        } catch (e) {
            return false;
        }
    }

    function isSessionStorageAvailable() {
        var test = 'test';
        try {
            sessionStorage.setItem("test", "test");
            sessionStorage.removeItem("test");
            return true;
        } catch (e) {
            return false;
        }
    }

    init();

    return {
        get: get,
        set: set,
        loadConfig: loadConfig,
        getValueAsync: getValueAsync,
        getContext: getContext,
        isLocalStorageAvailable: isLocalStorageAvailable,
        isSessionStorageAvailable: isSessionStorageAvailable,
        getClient: getClient
    };
}

ConfigService.$inject = ["_", "$log", "$http", "$window", "$q", "Events", "$rootScope"];//"socketIo",

export default angular.module("services.ConfigService", [lodash])
    .factory("ConfigService", ConfigService)
    .name;



// WEBPACK FOOTER //
// ./src/ui/app/services/ConfigService.js